/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArena = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14 2h8.414l-3 3 3 3H16v2h6v12h-5v-2c0-.551-.458-1-1-1s-1 .449-1 1v2H9v-2c0-.551-.458-1-1-1s-1 .449-1 1v2H2V2h8.414l-3 3 3 3H4v2h10zm6 10H4v8h1c0-1.654 1.377-3 3-3s3 1.346 3 3h2c0-1.654 1.377-3 3-3s3 1.346 3 3h1zM7 14v2H5v-2zm4 0v2H9v-2zm4 0v2h-2v-2zm4 0v2h-2v-2zM6.586 4H4v2h2.586l-1-1zm12 0H16v2h2.586l-1-1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgArena as Arena };
